import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: 'What is a home equity mortgage?',
  answer: "A home equity mortgage allows you to borrow against the equity you have built in your property. Unlike traditional mortgages, our solutions are based purely on your property's equity and location — no credit checks or income verification required."
}, {
  question: 'How much can I borrow?',
  answer: "You can typically borrow up to 80% of your home's appraised value, minus any existing mortgages. The exact amount depends on your property's location and current market value. Use our calculator above to get an instant estimate."
}, {
  question: 'Is there an age requirement?',
  answer: 'For most of our mortgage products, there is no age requirement. However, reverse mortgages are specifically designed for homeowners aged 55 and older. Contact us to discuss which product best suits your situation.'
}, {
  question: 'How quickly can I receive funds?',
  answer: 'Once approved, funds can be deposited into your account within 48 hours. Our streamlined process means no lengthy credit checks or income verification, allowing us to move quickly on your application.'
}, {
  question: 'Do you check credit scores?',
  answer: 'No, we do not perform credit checks. Our lending decisions are based entirely on your property equity and location, making our solutions accessible to homeowners regardless of their credit history.'
}, {
  question: 'What can I use the funds for?',
  answer: 'You can use the funds for any purpose: debt consolidation, home renovations, investment opportunities, emergency expenses, or any other financial need. There are no restrictions on how you use your home equity.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream py-20 px-4" data-id="element-60">
      <div className="max-w-4xl mx-auto" data-id="element-61">
        <div className="text-center mb-16" data-id="element-62">
          <span className="inline-block px-4 py-2 text-[12px] font-[Poppins,_sans-serif] text-[#07493a] bg-[#07493a1a] font-medium rounded-full mb-4 border border-primary/20 pt-[4px] pb-[4px] pl-[18px] pr-[18px]" data-id="element-63">
            COMMON QUESTIONS
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4 font-[500]" data-id="element-64">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600" data-id="element-65">
            Everything you need to know about our home equity solutions
          </p>
        </div>

        <div className="space-y-4" data-id="element-66">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-67">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-68">
                <span className="text-lg font-semibold text-gray-900 pr-8" data-id="element-69">
                  {faq.question}
                </span>
                <div className="flex-shrink-0 w-10 h-10 bg-primary rounded-lg flex items-center justify-center" data-id="element-70">
                  {openIndex === index ? <MinusIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-71" /> : <PlusIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-72" />}
                </div>
              </button>

              {openIndex === index && <div className="px-6 pb-6" data-id="element-73">
                  <div className="pt-2 border-t border-gray-100" data-id="element-74">
                    <p className="text-gray-700 leading-relaxed" data-id="element-75">
                      {faq.answer}
                    </p>
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}